import React, { useEffect } from "react";

import {
  Switch,
  Route,
  useLocation,
  useHistory,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";

import { useCookies } from "react-cookie";

import { useMediaQuery } from "react-responsive";

import { Button, Paper, Modal, Portal } from "@material-ui/core";

import { Context as PortalContext } from "../context/portal.context.js";
import { Context as AuthContext } from "../context/auth.context.js";

import { Provider as DealsProvider } from "../context/deals.context.js";
import { Provider as InvoicesProvider } from "../context/invoices.context.js";
import { Provider as HistoryProvider } from "../context/history.context.js";
import { Provider as WalletProvider } from "../context/wallet.context.js";

import DealIcon from "@material-ui/icons/LocalOfferOutlined";
import CardIcon from "@material-ui/icons/CreditCard";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import WalletIcon from "@material-ui/icons/AccountBalanceWalletOutlined";

import Deals from "./Deals";
import Invoices from "./Invoices";
import History from "./History";
import Wallet from "./Wallet";
import WelcomeBar from "../components/WelcomeBar";
import ToolBar from "../components/ToolBar";
import Footer from "../components/Footer";
import Login from "./Login";
import Loading from "./Loading";
import NoMatch from "./404";
import AddPaymentType from "./AddPaymentType";
import BottomNav from "../components/bottomNav.js";
import TextOptIn from "./TextOptIn.js";

const queryString = window.location.search;
let walletOnly = 0;

let params = new URLSearchParams(queryString);

if (params.has("walletOnly")) walletOnly = params.get("walletOnly");

const Home = (props) => {
  const [selected, setSelected] = React.useState("1");
  // const [authenticated, setAuthenticated] = React.useState(false);

  const [value, setValue] = React.useState(0);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [isDealerMerchant, setIsDealerMerchant] = React.useState(false);

  const portalState = React.useContext(PortalContext);
  const { hydratePortal } = React.useContext(PortalContext);
  const { logout } = React.useContext(AuthContext);
  const authState = React.useContext(AuthContext);
  const [cookies, removeCookie] = useCookies(["sessionID"]);

  let history = useHistory();

  // allowing overrides from the portalState
  if (walletOnly != 1 && portalState.state.walletOnly == 1) {
    walletOnly = 1;
  }

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isIpadProSmall = useMediaQuery({ query: "(max-width: 1300px" });

  const location = useLocation();
  let { path, url } = useRouteMatch();

  let { op } = useParams();

  const setSelectedRoute = () => {
    switch (location.pathname) {
      case `/${op}`:
        setSelected("1");
        break;
      case `/${op}/invoices`:
        setSelected("1");
        break;
      case `/${op}/history`:
        setSelected("2");
        break;
      case `/${op}/wallet`:
        setSelected("3");
        break;
      case `/${op}/deals`:
          setSelected("4");
          break;
      default:
        setSelected("1");
        break;
    }
  };

  useEffect(() => {
    // setAuthenticated(sessionStorage.getItem("authenticated"));
    setSelectedRoute();
  }, [window.location.pathname]);

  useEffect(() => {
    setIsDealerMerchant(portalState.state.dealerMerchant)
  }, [])



  function PrivateRoute({ children, ...rest }) {
    let authenticated = sessionStorage.getItem("authenticated");
    return (
      <Route
        {...rest}
        render={({ location }) =>
          authenticated ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: `/${op}/login`,
                state: { from: location },
              }}
            />
          )
        }
      />
    );
  }

  return (
    <div
      className="App"
      style={
        authState.state.authenticated
          ? { alignItems: "center" }
          : { alignItems: "flex-start" }
      }
    >
      <Loading />

      {authState.state.authenticated ? (
        <ToolBar logout={logout} hydratePortal={hydratePortal} />
      ) : null}

      {!isTabletOrMobile && authState.state.authenticated ? (
        <Paper
          elevation={0}
          style={{
            height: 90,
            width: "100%",
            borderBottom: "1px solid #e8e8e8",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div
            style={{
              maxWidth: 1300,
              width: 1300,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img
							src={
								portalState.state.merchantLogoURL != '' && portalState.state.merchantLogoURL?.split(".com")[1].includes(".")
								? portalState.state.merchantLogoURL
								: (portalState.state.verticalMarketLogo && portalState.state.verticalMarketLogo != ''? portalState.state.verticalMarketLogo : "https://secure.cpteller.com/img/logos/CPTellerLogo.png")
							}
              alt={"merchant-logo"}
              style={{maxHeight: '90px'}}
            />
            {authState.state.authenticated && authState.state.isFullAccount ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 150,
                }}
              >
                {!walletOnly && isDealerMerchant && (
                  <Button
                    style={{
                      fontSize: 18,
                      color: selected === "4" ? "#004887" : "#707070",

                      borderBottom:
                        selected === "4"
                          ? `2px solid ${props.theme.palette.secondary.main}`
                          : "none",

                      borderRadius: 0,
                      height: "100%",
                      marginRight: 35,
                    }}
                    disableElevation
                    variant={selected === "4" ? "text" : "text"}
                    startIcon={<DealIcon style={{ fontSize: 30 }} />}
                    key="4"
                    onClick={() => {
                      history.push(`/${op}/deals`);
                    }}
                  >
                    <x-lang>Deals</x-lang>
                  </Button>
                )}
                {!walletOnly && !isDealerMerchant && (
                  <Button
                    style={{
                      fontSize: 18,
                      color: selected === "1" ? "#004887" : "#707070",

                      borderBottom:
                        selected === "1"
                          ? `2px solid ${props.theme.palette.secondary.main}`
                          : "none",

                      borderRadius: 0,
                      height: "100%",
                      marginRight: 35,
                    }}
                    disableElevation
                    variant={selected === "1" ? "text" : "text"}
                    startIcon={<CardIcon style={{ fontSize: 30 }} />}
                    key="1"
                    onClick={() => {
                      history.push(`/${op}/invoices`);
                    }}
                  >
                    <x-lang>Invoices</x-lang>
                  </Button>
                )}

                {!walletOnly && (
                  <Button
                    className="nav-button"
                    style={{
                      fontSize: 18,
                      color: selected === "2" ? "#004887" : "#707070",
                      width: 150,
                      borderBottom:
                        selected === "2"
                          ? `2px solid ${props.theme.palette.secondary.main}`
                          : "none",
                      borderRadius: 0,
                      marginRight: 35,
                    }}
                    disableElevation
                    variant={selected === "2" ? "text" : "text"}
                    startIcon={<HistoryIcon style={{ fontSize: 30 }} />}
                    key="2"
                    onClick={() => {
                      history.push(`/${op}/history`);
                    }}
                  >
                    <x-lang>History</x-lang>
                  </Button>
                )}

                <Button
                  style={{
                    fontSize: 18,
                    color: selected === "3" ? "#004887" : "#707070",
                    width: 150,
                    borderBottom:
                      selected === "3"
                        ? `2px solid ${props.theme.palette.secondary.main}`
                        : "none",
                    borderRadius: 0,
                  }}
                  disableElevation
                  variant={selected === "3" ? "text" : "text"}
                  startIcon={<WalletIcon style={{ fontSize: 30 }} />}
                  key="3"
                  onClick={() => {
                    history.push(`/${op}/wallet`);
                  }}
                >
                  <x-lang>Wallet</x-lang>
                </Button>
              </div>
            ) : null}
          </div>
        </Paper>
      ) : null}

      {authState.state.authenticated && (
        <WelcomeBar selectedRoute={location.pathname} theme={props.theme} />
      )}

      <div
        className={"main-container"}
        style={{
          maxWidth: 1300,
          boxSizing: "border-box",
          width: "100%",
          height: window.location.pathname.includes("/login")
            ? "100vh"
            : "fit-content",
        }}
      >
        <Switch>
          <PrivateRoute exact path={`${path}/deals`}>
            <DealsProvider>
              <Deals theme={props.theme} />
            </DealsProvider>
          </PrivateRoute>
          <PrivateRoute exact path={`${path}/invoices`}>
            <InvoicesProvider>
              <Invoices theme={props.theme} />
            </InvoicesProvider>
          </PrivateRoute>
          <PrivateRoute exact path={`${path}/history`}>
            <HistoryProvider>
              <History theme={props.theme} />
            </HistoryProvider>
          </PrivateRoute>
          <PrivateRoute path={`${path}/wallet`}>
            <WalletProvider>
              <Wallet theme={props.theme} />
            </WalletProvider>
          </PrivateRoute>
          <PrivateRoute path={`${path}/wallet/addPaymentMethod`}>
            <WalletProvider>
              <AddPaymentType theme={props.theme} />
            </WalletProvider>
          </PrivateRoute>
          <Route exact path={`${path}/login`}>
            <Login
              //authenticated={authenticated}
              theme={props.theme}
            />
          </Route>
          <Route exact path={`${path}/optin`}>
            <TextOptIn />
          </Route>

          <Redirect from={`/${op}`} to={`/${op}/invoices`} exact />
          <Route path="*">
            <NoMatch />
          </Route>
          {/* <Redirect from="/" to="/invoices" exact /> */}
        </Switch>
      </div>
      {authState.state.authenticated && <Footer theme={props.theme} />}

      <Modal
        open={modalOpen}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
      >
        <Paper
          elevation={3}
          style={{
            padding: 25,
            width: 300,
            background: "white",
            outline: "none",
            borderRadius: 5,
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span><x-lang>Do you wish to stay logged in?</x-lang></span>

          <Button
            variant="contained"
            color="secondary"
            style={{
              marginTop: 25,
              marginBottom: 15,
              color: "white",
            }}
            onClick={() => setModalOpen(false)}
          >
            <x-lang>Stay Logged In</x-lang>
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              logout({
                sessionID: cookies.sessionID,
                removeCookie,
                queryString: window.location.search,
              });
            }}
          >
            <x-lang>Exit</x-lang>
          </Button>
        </Paper>
      </Modal>
      {isTabletOrMobile && authState.state.isFullAccount ? <BottomNav isDealerMerchant={isDealerMerchant}/> : null}
    </div>
  );
};

export default Home;
